import { render, staticRenderFns } from "./FuncionalidadeHandler.vue?vue&type=template&id=77d1bb69&scoped=true"
import script from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeHandler.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeHandler.vue?vue&type=style&index=0&id=77d1bb69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1bb69",
  null
  
)

export default component.exports